import { style } from "@vanilla-extract/css";

/**
 * Fixed, like the View picker's slot below it, but narrower: it ends the
 * dimension row, where twelve dropdowns already share the width. It
 * ellipsises the name that doesn't fit.
 */
export const contextPickerSlot = style({
  display: "flex",
  flex: "0 0 15rem",
  minWidth: 0
});
